import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import StudentApp from './StudentApp';
import Login from './Auth/Login';
import InvestorApp from './InvestorApp';
import InvesterRegister from './Auth/InvesterRegister';
import AdminApp from './AdminApp';
import { useEffect } from 'react';
import LandingPage from './LandingPage';
import Otpverification from './Auth/Otpverification';
import StudentRegister from './Auth/StudentRegister';
import OtpVerificationinves from './Auth/Otpverificationinves';
import Jobformp3 from './Auth/Jobformp3';
import ForgotP from './Auth/ForgotP';
import FeedbackForm from './Auth/FeedbackForm';
import CheckScore from './Auth/CheckScore';
import Stratupregister from './Auth/StartupRegisteration';
import Otpverifcationstartup from './Auth/Otpverifcationstartup';


function App() {
  useEffect(() => {
    // Add Google Tag Manager script
    const gtmScript = document.createElement('script');
    gtmScript.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-TKBH7324');
    `;
    document.head.appendChild(gtmScript);
 
    // Add Google Analytics script
    const gaScript = document.createElement('script');
    gaScript.async = true;
    gaScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-18C6K4KV6C';
    document.head.appendChild(gaScript);
 
    const gaInitScript = document.createElement('script');
    gaInitScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-18C6K4KV6C');
    `;
    document.head.appendChild(gaInitScript);
  }, []);
  return (
    <div className="App">
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-TKBH7324"
          height="0"
          width="0"
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
      <Router>
        <Routes>
                
                 <Route path="/Login@punestartupexpo" element={<Login/>}/>
                 <Route path="/invesRegis" element={<InvesterRegister/>}/>
                 <Route path="/StudentRegister" element={<StudentRegister/>}/>
                 <Route path="/StartupRegister" element={<Stratupregister/>}/>
                 <Route path="/FeedbackForm" element={<FeedbackForm/>}/>
                 <Route path='/Otpverification' element={<Otpverification/>}/>
                 <Route path='/Otpverificationstartup' element={<Otpverifcationstartup/>}/>
                 <Route path="/" element={<LandingPage/>}/>
                 <Route path="/Otpverificationinves" element={<OtpVerificationinves/>}/>

                 <Route path="/jobformp3" element={<Jobformp3/>}/>

                 <Route path="/forgotpassword" element={<ForgotP/>}/>

                 <Route path="/InvestorApp/*" element={<InvestorApp />} />
                 <Route path="/StudentApp/*" element={<StudentApp />} />
                 <Route path="/AdminApp/*" element={<AdminApp />} />
                 <Route path="/check-score/3f8a7c0e-b9d2-11ee-a1f1-0242ac120002-7e9d1f5d3c8b4f2aa9a6e8d2c7b9e0f1/ZXlKaGJHY2lPaUpJVXpJMU5pSXNJbXRwWkNJNklrTnphVzl1ZEd4cFpYTXRNVEV3TURFeU1pSXNJbWx6Y3lJNkltaDBkSEJ6T2k4dmQzZDNMblZ6WlhKMExYSmxibU5wWjI1bFpDQjRQU0o5/9f86d23ca1ab4d47b18f3ad2eaaad83c9f49a7b8e6d64b3dbf1ea4f9cfae2389" element={<CheckScore />} />

        </Routes>
      </Router>
      
    </div>
  );
}

export default App;
